import $ from 'jquery';

$.onAuth(auth => {
  const Tawk = window.Tawk_API;
  if (!Tawk) return;

  function hideWidget() {
    if (Tawk.isChatMinimized()) Tawk.hideWidget();
  }

  Tawk.onLoad = function () {
    Tawk.hideWidget();
    Tawk.onChatMinimized = hideWidget;
    Tawk.onStatusChange = hideWidget;
    setInterval(hideWidget, 1000);

    $(document).on('click', '.btn-chat', () => {
      Tawk.popup();
    });
  };
});
